import { subStepsIds } from '../WizardModel/constants'

let wf_adult_myself = [
    {
        id: subStepsIds.ParticipantType,
        getNextStepId: (state) => {
            if (state.isLinked === true) {
                return subStepsIds.ViewBowlerInfo;
            } else {
                return subStepsIds.BowlerMembership;
            }
        }
    },
    {
        id: subStepsIds.BowlerMembership,
        getNextStepId: (state) => {
            if (state.bowlerMembership == "Yes") {
                return subStepsIds.MembershipSearch;
            } else {
                return subStepsIds.EditBowlerInfo;
            }
        }
    },
    {
        id: subStepsIds.MembershipSearch,
        getNextStepId: (state) => {
            return subStepsIds.ViewBowlerInfo;
        }
    },
    {
        id: subStepsIds.MembershipCostAck,
        getNextStepId: (state) => {
            return subStepsIds.Consent;

        }
    },
    {
        id: subStepsIds.ViewBowlerInfo,
        getNextStepId: (state) => {
            if (state.isMemberFoundBySearch === true) {
                return subStepsIds.Consent;
            } else {
                if (state.hasCurrentNationalLevelMembership === true) {
                    return subStepsIds.Consent;
                } else {
                    return subStepsIds.MembershipCostAck;
                }
            }
        }
    },
    {
        id: subStepsIds.EditBowlerInfo,
        getNextStepId: (state) => {
            return subStepsIds.MembershipCostAck;
        }
    },
    {
        id: subStepsIds.Consent,
        getNextStepId: (state) => {
            if (state.isPaymentRequired)
                return subStepsIds.ReviewAndPay;
            else
                return subStepsIds.Finished;
        }
    },
    {
        id: subStepsIds.ReviewAndPay,
        getNextStepId: (state) => {
            return subStepsIds.Finished;
        }
    },
];

export default wf_adult_myself;

